<template>
  <ul class="types">
    <li>
      <button
        class="types__button"
        :class="{ 'types__button--active': isShopAllSelected }"
        @click="handleTypeClick({ productType: null })"
      >
        Shop all
      </button>
    </li>
    <li v-for="type in types" :key="type.id">
      <button
        class="types__button"
        :class="{ 'types__button--active': isFilterSelected(type) }"
        @click="handleTypeClick(type.input)"
      >
        {{ type.label }} ({{ type.count }})
      </button>
    </li>
  </ul>
</template>

<script>
import isEqual from "lodash-es/isEqual";

export default {
  name: "ProductTypes",
  props: {
    types: {
      type: Array,
      default: () => [],
    },
    selectedFilters: {
      type: Array,
      default: () => [],
    },
  },
  emits: ["change"],
  computed: {
    isShopAllSelected() {
      const hasProductTypes = this.selectedFilters.some((selectedFilter) => {
        return selectedFilter["productType"];
      });
      return !hasProductTypes;
    },
  },
  methods: {
    isFilterSelected(value) {
      const valueInput = JSON.parse(value.input);
      const filterKey = Object.keys(valueInput)[0];

      const selectedFiltersHasSelectedFilter = this.selectedFilters?.some(
        (selectedFilter) => {
          if (isEqual(selectedFilter[filterKey], valueInput[filterKey])) {
            return true;
          }
          return false;
        }
      );
      return selectedFiltersHasSelectedFilter;
    },
    handleTypeClick(input) {
      let emittedValue = input;

      if (typeof input == "string") {
        emittedValue = JSON.parse(input);
      }

      this.$emit("change", emittedValue);
    },
  },
};
</script>

<style lang="scss" scoped>
.types {
  overflow: auto;
  white-space: nowrap;

  &::-webkit-scrollbar {
    display: none;
  }

  @include respond-above(md) {
    overflow-y: auto;
  }

  li {
    display: inline-block;

    &:first-child {
      .types__button {
        padding-left: 20px;
        @include respond-above(md) {
          padding-left: 0;
        }
      }
    }

    &:last-child {
      .types__button {
        padding-right: 16px;
      }
    }
  }

  &__button {
    background: none;
    outline: none;
    border: none;
    @include t__utility-label-20;
    padding: 20px 8px;
    letter-spacing: 0.49px;
    opacity: 0.3;

    &--active {
      font-weight: 600;
      opacity: 1;
      text-decoration: underline;
    }
  }
}
</style>
